import angular from "angular";

export default angular.module("app.constants", []).value("Constants", {
  DEFAULT_MESSAGES: "modules/dcb-eaccount/errors/errors.tpl.html",
  FRONTEND_ACTION_HEADER: "dcb-frontend-action",
  PIN_CHANGE_REQUEST_IDENTIFIER: "PIN_CHANGE_REQUEST",
  LOCK_CARD_REQUEST_IDENTIFIER: "LOCK_CARD_REQUEST",
  ADDITIONAL_SETTING_REQUEST_IDENTIFIER: "ADDITIONAL_SETTING_REQUEST_IDENTIFIER_REQUEST",
  ADVERTISEMENT_TYPE_URL: "URL",
  ADVERTISEMENT_TYPE_BESTPAY: "BESTPAY",
  ADVERTISEMENT_TYPE_BONUSSHOP: "BONUSSHOP"
})
  .constant("invoiceFilterMapping",
    {
      fakDateFrom: { field: "fakDateFrom", type: "date" },
      fakDateUntil: { field: "fakDateUntil", type: "date" },
      dueDateFrom: { field: "dueDateFrom", type: "date" },
      dueDateUntil: { field: "dueDateUntil", type: "date" },
      description: "$q",
      download: "download",
      settled: "settled",
      id: "id",
      amountFrom: { field: "amount.valueFrom", type: "number" },
      amountUntil: { field: "amount.valueUntil", type: "number" },
      name: "contract.formattedName",
      identifier: "contractIdentifier"
    })
  .constant("cardFilterMapping", {
    cardNr: "cardNr",
    basicAgreementName: "basicAgreementName",
    validFrom: { field: "displayValidFrom", type: "date" },
    validUntil: { field: "displayValidUntil", type: "date" },
    name: "formattedName",
    type: "product.description",
    trxYTDFrom: { field: "aggregatedData.transactionsThisYear.valueFrom", type: "number" },
    trxYTDUntil: { field: "aggregatedData.transactionsThisYear.valueUntil", type: "number" },
    trx365From: { field: "aggregatedData.transactions365.valueFrom", type: "number" },
    trx365Until: { field: "aggregatedData.transactions365.valueUntil", type: "number" },
    loungeFrom: { field: "aggregatedData.loungeVisitsFrom", type: "number" },
    loungeUntil: { field: "aggregatedData.loungeVisitsUntil", type: "number" }
  })
  .constant("transactionFilterMapping",
    {
      chargetypeCode: "chargetypeGroup.code",
      chargetypeName: "chargetypeGroup.name",
      dateFrom: { field: "tranDateFrom", type: "date" },
      dateUntil: { field: "tranDateUntil", type: "date" },
      invDateFrom: { field: "fakDateFrom", type: "date" },
      invDateUntil: { field: "fakDateUntil", type: "date" },
      description: "$q",
      amountFrom: { field: "amount.valueFrom", type: "number" },
      amountUntil: { field: "amount.valueUntil", type: "number" },
      originalAmountFrom: { field: "originalAmount.valueFrom", type: "number" },
      originalAmountUntil: { field: "originalAmount.valueUntil", type: "number" },
      settled: "settled",
      page: "page"
    })
  .constant("exchangeRateFilterMapping", {
    targetCurrency: "targetCurrency",
    exchangeRateDate: "exchangeRateDate",
    amountInEUR: "amountInEUR"
  })
  /*.constant("adminEmailsFilterMapping",{
   createdAt: "createdAt", // createdAtFrom // createdAtUntil
    sentAt: "sentAt", // sentAtFrom // sentAtUntil
    to : "to",
    template: "template",
    subject: "subject"
  })*/

  .name;



// WEBPACK FOOTER //
// ./src/ui/app/services/Constants.js